// @generated by protoc-gen-es v1.10.0
// @generated from file fingertip/creator/schedule/v1/schedule.proto (package fingertip.creator.schedule.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { Schedule, ScheduleAvailabilities } from "../../../common/type/v1/schedule_pb.js";
import { PageInfo } from "../../../common/type/v1/page_info_pb.js";
import { UserProfile } from "../../../common/type/v1/user_profile_pb.js";
import { EventType } from "../../../common/type/v1/event_type_pb.js";

/**
 * @generated from message fingertip.creator.schedule.v1.GetSchedulesRequest
 */
export const GetSchedulesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.schedule.v1.GetSchedulesRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "search", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.schedule.v1.GetSchedulesResponse
 */
export const GetSchedulesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.schedule.v1.GetSchedulesResponse",
  () => [
    { no: 1, name: "schedules", kind: "message", T: Schedule, repeated: true },
    { no: 2, name: "total", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "page_info", kind: "message", T: PageInfo },
  ],
);

/**
 * @generated from message fingertip.creator.schedule.v1.GetScheduleRequest
 */
export const GetScheduleRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.schedule.v1.GetScheduleRequest",
  () => [
    { no: 1, name: "schedule_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.schedule.v1.GetScheduleResponse
 */
export const GetScheduleResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.schedule.v1.GetScheduleResponse",
  () => [
    { no: 1, name: "schedule", kind: "message", T: Schedule },
  ],
);

/**
 * @generated from message fingertip.creator.schedule.v1.CreateScheduleRequest
 */
export const CreateScheduleRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.schedule.v1.CreateScheduleRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "availabilities", kind: "message", T: ScheduleAvailabilities, repeated: true },
    { no: 5, name: "date_overrides", kind: "message", T: ScheduleAvailabilities, repeated: true },
    { no: 6, name: "time_zone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.schedule.v1.CreateScheduleResponse
 */
export const CreateScheduleResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.schedule.v1.CreateScheduleResponse",
  () => [
    { no: 1, name: "schedule", kind: "message", T: Schedule },
  ],
);

/**
 * @generated from message fingertip.creator.schedule.v1.UpdateScheduleRequest
 */
export const UpdateScheduleRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.schedule.v1.UpdateScheduleRequest",
  () => [
    { no: 1, name: "schedule_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "availabilities", kind: "message", T: ScheduleAvailabilities, repeated: true },
    { no: 5, name: "date_overrides", kind: "message", T: ScheduleAvailabilities, repeated: true },
    { no: 6, name: "time_zone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.schedule.v1.UpdateScheduleResponse
 */
export const UpdateScheduleResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.schedule.v1.UpdateScheduleResponse",
  () => [
    { no: 1, name: "schedule", kind: "message", T: Schedule },
  ],
);

/**
 * @generated from message fingertip.creator.schedule.v1.DeleteScheduleRequest
 */
export const DeleteScheduleRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.schedule.v1.DeleteScheduleRequest",
  () => [
    { no: 1, name: "schedule_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.schedule.v1.DeleteScheduleResponse
 */
export const DeleteScheduleResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.schedule.v1.DeleteScheduleResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.schedule.v1.CreateEventTypeScheduleMappingRequest
 */
export const CreateEventTypeScheduleMappingRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.schedule.v1.CreateEventTypeScheduleMappingRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "event_type_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "schedule_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.schedule.v1.GetEventTypeScheduleMappingsRequest
 */
export const GetEventTypeScheduleMappingsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.schedule.v1.GetEventTypeScheduleMappingsRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "event_type_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "schedule_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.schedule.v1.EventTypeScheduleMapping
 */
export const EventTypeScheduleMapping = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.schedule.v1.EventTypeScheduleMapping",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "schedule", kind: "message", T: Schedule },
    { no: 3, name: "user", kind: "message", T: UserProfile },
    { no: 4, name: "event_type", kind: "message", T: EventType },
  ],
);

/**
 * @generated from message fingertip.creator.schedule.v1.GetEventTypeScheduleMappingsResponse
 */
export const GetEventTypeScheduleMappingsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.schedule.v1.GetEventTypeScheduleMappingsResponse",
  () => [
    { no: 1, name: "event_type_schedules", kind: "message", T: EventTypeScheduleMapping, repeated: true },
  ],
);

/**
 * @generated from message fingertip.creator.schedule.v1.CreateEventTypeScheduleMappingResponse
 */
export const CreateEventTypeScheduleMappingResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.schedule.v1.CreateEventTypeScheduleMappingResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.schedule.v1.DeleteEventTypeScheduleMappingRequest
 */
export const DeleteEventTypeScheduleMappingRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.schedule.v1.DeleteEventTypeScheduleMappingRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "event_type_schedule_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.schedule.v1.DeleteEventTypeScheduleMappingResponse
 */
export const DeleteEventTypeScheduleMappingResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.schedule.v1.DeleteEventTypeScheduleMappingResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.schedule.v1.GetEventTypesScheduledMembersPublicRequest
 */
export const GetEventTypesScheduledMembersPublicRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.schedule.v1.GetEventTypesScheduledMembersPublicRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "event_types", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 5 /* ScalarType.INT32 */} },
  ],
);

/**
 * @generated from message fingertip.creator.schedule.v1.GetEventTypesScheduledMembersPublicResponse
 */
export const GetEventTypesScheduledMembersPublicResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.schedule.v1.GetEventTypesScheduledMembersPublicResponse",
  () => [
    { no: 1, name: "members", kind: "message", T: UserProfile, repeated: true },
  ],
);

